/**
 * StaffTaskTimelineCard — 대시보드(실시간 현황)의 총무 업무 칸
 *
 * 🔴 2026-10-01 대표 지시: 종전엔 하루 업무 130여 개를 시간순으로 늘어놓은 목록이라
 *    "그냥 목록만 있어서 좋지 않다". 지금은 진행률 / 지금 할 일 / 놓친 일 / 다음 할 일만 보여준다.
 *    전체 목록은 [직원 현황] → 「총무 업무」 탭에 있다.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ownerLayoutService } from '../../services/OwnerLayoutService';
import StaffTaskNowPanel from './StaffTaskNowPanel';
import './StaffTaskTimelineCard.css';

const StaffTaskTimelineCard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="staff-task-card">
      <div className="stc-header">
        <h2>🧹 총무 업무 · 지금</h2>
        <div className="stc-header-right">
          <button className="stc-edit-btn" onClick={() => navigate(`${ownerLayoutService.getOwnerPath('/owner/staff-hub')}?tab=tasks`)}>
            전체 보기
          </button>
          <button className="stc-edit-btn" onClick={() => navigate(ownerLayoutService.getOwnerPath('/owner/staff-tasks'))}>
            업무 편집
          </button>
        </div>
      </div>
      <StaffTaskNowPanel compact />
    </div>
  );
};

export default StaffTaskTimelineCard;
